import { AxiosError } from "axios";
import { getApi } from "../CreateApi";
import {
  CobranzaMetodosPago,
  DeudorMorosidad,
  EvolucionCobranzaMensual,
  MonthlyIncomeResponse,
  MorosidadAging,
  MorosidadMensual,
  MorosidadPorConcepto,
  MorosidadPorNivel,
  TasaMorosidadMensual,
} from "./treasuryReports.interface";

export const getMorosidadMensual = async (params: {
  yearId: string;
  campusDetailId: string;
  levelId: string;
  dateFrom: string;
  dateTo: string;
}): Promise<MorosidadMensual[]> => {
  try {
    const data = await getApi(`/treasury/reports/morosidad/mensual`, params);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const getTasaMorosidadMensual = async (params: {
  yearId: string;
  campusDetailId: string;
  levelId: string;
  dateFrom: string;
  dateTo: string;
}): Promise<TasaMorosidadMensual[]> => {
  try {
    const data = await getApi(
      `/treasury/reports/morosidad/tasa-mensual`,
      params,
    );
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const getDeudoresMorosidad = async (params: {
  yearId: string;
  campusDetailId: string;
  levelId: string;
  dateFrom: string;
  dateTo: string;
}): Promise<DeudorMorosidad[]> => {
  try {
    const data = await getApi(`/treasury/reports/morosidad/deudores`, params);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const getMorosidadPorNivel = async (params: {
  yearId: string;
  campusDetailId: string;
  levelId: string;
  dateFrom: string;
  dateTo: string;
  conceptId: number;
}): Promise<MorosidadPorNivel[]> => {
  try {
    const data = await getApi(`/treasury/reports/morosidad/por-nivel`, params);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const getMorosidadPorConcepto = async (params: {
  yearId: string;
  campusDetailId: string;
  levelId: string;
  dateFrom: string;
  dateTo: string;
}): Promise<MorosidadPorConcepto[]> => {
  try {
    const data = await getApi(
      `/treasury/reports/morosidad/por-concepto`,
      params,
    );
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const getMorosidadAging = async (params: {
  yearId: string;
  campusDetailId: string;
  levelId: string;
  dateFrom: string;
  dateTo: string;
}): Promise<MorosidadAging> => {
  try {
    const data = await getApi(`/treasury/reports/morosidad/aging`, params);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const getEvolucionCobranza = async (params: {
  yearId: string;
  campusDetailId: string;
  levelId: string;
  dateFrom: string;
  dateTo: string;
}): Promise<EvolucionCobranzaMensual[]> => {
  try {
    const data = await getApi(
      `/treasury/reports/cobranza/evolucion-mensual`,
      params,
    );
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const getCobranzaMetodosPago = async (params: {
  yearId: string;
  campusDetailId: string;
  levelId: string;
  dateFrom: string;
  dateTo: string;
}): Promise<CobranzaMetodosPago> => {
  try {
    const data = await getApi(
      `/treasury/reports/cobranza/metodos-pago`,
      params,
    );
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const getMonthlyIncome = async (params: {
  yearId: string;
  conceptId: string;
  dateFrom: string;
  dateTo: string;
  campusDetailId: string;
  levelId: string;
}): Promise<MonthlyIncomeResponse> => {
  try {
    const data = await getApi(
      `/treasury/reports/cobranza/ingresos-mensuales`,
      params,
    );
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};
